import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { LOGO, PHONE_DISPLAY, PHONE_TEL } from "../../lib/site";

const NAV = [
  { label: "Services", href: "/#services" },
  { label: "Service Areas", href: "/#areas" },
  { label: "Why Us", href: "/#why" },
  { label: "Reviews", href: "/#reviews" },
  { label: "FAQ", href: "/#faq" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-200 ${
        scrolled ? "bg-[#0A1E3F] border-b-2 border-[#C8102E]" : "bg-[#0E2A56]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20 sm:h-24">
        <a href="/" data-testid="header-logo" className="flex items-center gap-3">
          <img src={LOGO} alt="Journey's Handyman Services logo" className="h-16 sm:h-[4.5rem] w-auto object-contain bg-white rounded-lg p-1" />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-heading font-semibold uppercase tracking-wide text-white/90 hover:text-[#C8102E] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="header-call-button"
            className="hidden sm:inline-flex items-center gap-2 bg-[#C8102E] hover:bg-[#9E0C24] text-white font-heading font-bold uppercase tracking-wide px-5 py-3 transition-colors"
          >
            <Phone className="h-5 w-5" strokeWidth={2.5} />
            {PHONE_DISPLAY}
          </a>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            className="lg:hidden text-white"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="h-8 w-8" /> : <Menu className="h-8 w-8" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A1E3F] border-t border-white/10 px-4 py-4 space-y-1">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="block font-heading font-semibold uppercase tracking-wide text-white py-2 border-b border-white/5"
            >
              {n.label}
            </a>
          ))}
          <a
            href={`tel:${PHONE_TEL}`}
            className="mt-3 flex items-center justify-center gap-2 bg-[#C8102E] text-white font-heading font-bold uppercase px-5 py-3"
          >
            <Phone className="h-5 w-5" /> Call {PHONE_DISPLAY}
          </a>
        </div>
      )}
    </header>
  );
};
